import React, { Component } from 'react'
import PropTypes from 'prop-types'

import './style.scss'

const INPUT_TEXT_TYPE = 'text'

export default class Input extends Component {
    static propTypes = {
        input: PropTypes.object,
        label: PropTypes.string,
        meta: PropTypes.object,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onDragStart: PropTypes.func,
        onDrop: PropTypes.func,
        onFocus: PropTypes.func,
        placeholder: PropTypes.string,
        type: PropTypes.string,
    }

    static defaultProps = {
        type: INPUT_TEXT_TYPE,
    }

    handleOnCustomChange = (event) => {
        const {
            props: { onChange, input },
        } = this
        if (onChange) {
            onChange(event.target.value)
        }
        return input.onChange(event)
    }

    handleOnCustomBlur = (event) => {
        const {
            props: { onBlur, input },
        } = this
        if (onBlur) {
            onBlur(event.target.value)
        }
        return input.onBlur(event)
    }

    handleOnCustomDragStart = (event) => {
        const {
            props: { onDragStart, input },
        } = this
        if (onDragStart) {
            onDragStart(event.target.value)
        }
        return input.onDragStart(event)
    }

    handleOnCustomDrop = (event) => {
        const {
            props: { onDrop, input },
        } = this
        if (onDrop) {
            onDrop(event.target.value)
        }
        return input.onDrop(event)
    }

    handleOnCustomFocus = (event) => {
        const {
            props: { onFocus, input },
        } = this
        if (onFocus) {
            onFocus(event.target.value)
        }
        return input.onFocus(event)
    }

    render() {
        const {
            props: {
                placeholder,
                label,
                meta: { touched, error },
                type,
                input,
            },
            handleOnCustomChange,
            handleOnCustomFocus,
            handleOnCustomDrop,
            handleOnCustomDragStart,
            handleOnCustomBlur,
        } = this

        return (
            <div>
                {label && (
                    <label className="input-label" htmlFor={label}>
                        {label}
                    </label>
                )}
                <div>
                    <input
                        {...input}
                        className="cstm-input-field"
                        onDrop={handleOnCustomDrop}
                        onDragStart={handleOnCustomDragStart}
                        onFocus={handleOnCustomFocus}
                        onBlur={handleOnCustomBlur}
                        onChange={handleOnCustomChange}
                        placeholder={placeholder}
                        type={type}
                    />
                    {touched && error && <span className="input-error">{error}</span>}
                </div>
            </div>
        )
    }
}
